import { createReducer, on } from '@ngrx/store';
import { GroupApiActions } from './groups-of-group.actions';
import { adapter, initialstate } from './groups-of-group.state';

export const groupsOfGroupReducer = createReducer(
  initialstate,
  on(GroupApiActions.userGroupsLoaded, (state, { groups }) => adapter.addMany(groups, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectGroupsOfGroupIds = selectIds;

export const selectGroupsOfGroupEntities = selectEntities;

export const selectAllGroups = selectAll;
